var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOneshot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.304 0h40v40h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M21.002 12l18 8-18 8v-6H3.607v-4h17.395v-6z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOneshot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/oneshot.3800756453e79bd3314c906050c48e66.svg";